<template>
  <div class="main-container billing-table-height">
    <vk-offcanvas-content>
      <vk-offcanvas flipped overlay stuck :show.sync="showUpdate">
        <vk-offcanvas-close @click="showUpdate = false"></vk-offcanvas-close>
        <billing-update :updateData="this.updateParams"></billing-update>
      </vk-offcanvas>
    </vk-offcanvas-content>
    <div style="width: 100%">
      <h3 class="pagin_style">
        Showing
        {{
          paginationInfo.total > 0
            ? `${paginationInfo.first} - ${paginationInfo.last}
        ${paginationInfo.ofText} ${paginationInfo.total} ${
                paginationInfo.total > 1 ? "Devices" : "Device"
              }`
            : "no device"
        }}
      </h3>
      <el-input
        style="width: 30%"
        class="el-input el-input--prefix"
        placeholder="Type Customers ID"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :lineNumbers="true"
        :columns="fields"
        :rows="this.getUsers"
        :search-options="{
          enabled: true,
          searchFn: searchTable,
          externalQuery: searchTerm
        }"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'customerName'">
            {{ props.row.user ? props.row.user.firstname : "----" }}
            {{ props.row.user ? props.row.user.lastname : "----" }}
          </span>

          <span v-if="props.column.field == 'deviceId'">
            {{ props.row.installation ? props.row.installation.cid : "----" }}
          </span>

          <span v-if="props.column.field == 'totalPrice'">
            {{
              (parseInt(props.row.totalPrice)
                ? parseInt(props.row.totalPrice)
                : "----"
              ).toLocaleString()
            }}
          </span>

          <span v-if="props.column.field == 'monthlyCharge'">
            {{
              (parseInt(props.row.monthlyCharge)
                ? parseInt(props.row.monthlyCharge)
                : "----"
              ).toLocaleString()
            }}
          </span>

          <span v-if="props.column.field == 'totalPaid'">
            {{
              (parseInt(props.row.totalAmountPaid)
                ? parseInt(props.row.totalAmountPaid)
                : "----"
              ).toLocaleString()
            }}
          </span>

          <span v-if="props.column.field == 'numberOfTimesPaymentIsMade'">
            {{
              props.row.numberOfTimesPaymentIsMade
                ? props.row.numberOfTimesPaymentIsMade
                : "----"
            }}
          </span>

          <span v-if="props.column.field == 'monthlyRecurringChargeDate'">
            {{
              formatDate(props.row.monthlyrecurringchargedate)
                ? formatDate(props.row.monthlyrecurringchargedate)
                : "----"
            }}
          </span>

          <span v-if="props.column.field == 'paymentMethod'">
            {{ props.row.paymentMethod ? props.row.paymentMethod : "----" }}
          </span>

          <span v-if="props.column.field == 'isDefaultCard'">
            {{
              props.row.cardInfo
                ? props.row.cardInfo.isdefaultcard
                  ? "Yes"
                  : "No"
                : "----"
            }}
          </span>
          <span v-if="props.column.field == 'actions'">
            <div class="action_style">
              <a-dropdown :trigger="['click']">
                <p class="ant-dropdown-link ellipsis_style">
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </p>
                <template slot="overlay">
                  <a-menu>
                    <a-menu-item class="action_update" key="0">
                      <p
                        @click="
                          updateBilling(
                            props.row.id,
                            props.row.installation.cid,
                            props.row.monthlyCharge,
                            props.row.numberOfTimesPaymentIsMade,
                            formatDate(props.row.monthlyrecurringchargedate),
                            props.row.duration,
                            props.row.totalPrice,
                            props.row.user.firstname,
                            props.row.user.lastname
                          )
                        "
                      >
                        <i class="fas fa-edit"> Edit </i>
                      </p>
                    </a-menu-item>
                    <a-menu-item class="action_delete" key="1">
                      <p
                        @click="
                          deleteModal(
                            props.row.installation
                              ? parseInt(props.row.installation.cid)
                              : 0,
                            parseInt(props.row.id),
                            props.row.user.firstname,
                            props.row.user.lastname
                          )
                        "
                      >
                        <i class="fa fa-trash"> Delete</i>
                      </p>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
          </span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
            @paginated-info="paginationInfo = $event"
          ></grey-pagination>
        </template>
      </vue-good-table>

      <modal
        width="500px"
        height="auto"
        name="my-first-modal"
        style="border-radius: 28px !important"
        class="first-modal"
      >
        <div class="form">
          <form name="myForm">
            <p class="triangle">
              <i
                class="fa fa-exclamation-triangle fa-3x"
                style="
                  color: red;
                  background-color: pink;
                  border-radius: 50%;
                  width: 45px;
                  height: 47px;
                  margin: 16px;
                "
                aria-hidden="true"
              ></i>
            </p>
            <h4>Are you sure you want to delete this billing record?</h4>
            <p style="text-align: center">
              "{{ userName }} - {{ idSelected }}"
            </p>
            <input
              type="text"
              class="form-control form-control"
              :required="true"
              v-model="deleteReason"
              placeholder="comment"
            />

            <div class="row">
              <button type="submit" class="button-cancel" @click="cancel">
                Cancel
              </button>
              <button
                type="submit"
                class="button-delete"
                @click.prevent="deletionDetails(deleteDevice())"
                disabled
              >
                Delete
              </button>
            </div>
          </form>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioButton,
  RadioGroup
} from "element-ui";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  Offcanvas,
  OffcanvasClose,
  OffcanvasContent
} from "vuikit/lib/offcanvas";
import BillingUpdate from "../users/BillingUpdate.vue";
moment.updateLocale("en", {
  monthsShort: "Jan_Feb_Mar_Apr_May_June_July_Aug_Sept_Oct_Nov_Dec".split("_")
});

const items = [];
export default {
  name: "BillingListing",
  components: {
    "vk-offcanvas-content": OffcanvasContent,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    "billing-update": BillingUpdate
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      paginationInfo: {},
      updateParams: {
        id: "",
        installationCID: "",
        monthlyCharge: "",
        numbOfpayment: "",
        chargeDate: "",
        pDuration: "",
        amounts: "",
        FullName: ""
      },
      showUpdate: false,
      paginatedInfo: {},
      searchTerm: "",
      editOffCanvas: false,
      isLoading: false,
      idSelected: "",
      userName: "",
      disableButton: "",
      userID: "",
      regParams: {},
      selectOption: {
        enabled: true
      },
      items: items,

      fields: [
        {
          field: "customerName",
          label: "CUSTOMER NAME",
          sortable: "true"
        },
        {
          field: "deviceId",
          label: "DEVICE ID",
          sortable: "true"
        },
        {
          field: "totalPrice",
          label: "TOTAL PRICE (₦)",
          sortable: "true"
        },
        {
          field: "monthlyCharge",
          label: "MONTHLY CHARGE (₦)",
          sortable: "true"
        },
        {
          field: "totalPaid",
          label: "TOTAL PAID (₦)",
          sortable: "true"
        },
        {
          field: "numberOfTimesPaymentIsMade",
          label: "PAYMENT COUNT",
          sortable: "true"
        },
        {
          field: "monthlyRecurringChargeDate",
          label: "RECURRING DATE",
          sortable: "true"
        },
        {
          field: "paymentMethod",
          label: "PAYMENT METHOD",
          sortable: "false"
        },
        {
          field: "isDefaultCard",
          label: "ONBOARDED CARD?",
          sortable: "false"
        },
        {
          field: "actions",
          label: "",
          sortable: "false"
        }
      ],
      getUsers: [],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      showModal: true,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  computed: {
    ...mapGetters(["getUsers"]),
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    },
    toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    deleteModal(data1, data2, firstName, lastName) {
      this.idSelected = data1;
      this.userID = data2;
      let FIRSTname = firstName;
      let LASTname = lastName;
      let dataName = `${FIRSTname} ${LASTname}`;
      this.userName = dataName;
      console.log(
        `installation - ${this.idSelected}:: userID - ${this.userID}:: Customer's name -- ${this.userName}`
      );
      this.show();
    },
    updateBilling(
      Id,
      CID,
      Charges,
      NoOfPayment,
      ChargeDate,
      Duration,
      Amount,
      firstName,
      lastName
    ) {
      this.updateParams.id = Id;
      this.updateParams.installationCID = CID;
      this.updateParams.monthlyCharge = Charges;
      this.updateParams.numbOfpayment = NoOfPayment;
      this.updateParams.chargeDate = ChargeDate;
      this.updateParams.pDuration = Duration;
      this.updateParams.amounts = Amount;
      let fullName = `${firstName} ${lastName}`;
      this.updateParams.FullName = fullName;
      this.showUpdate = true;
    },
    cancel() {
      this.idSelected = "";
      this.userID = "";
      this.hide();
    },
    deleteDevice() {
      const HTTP = this.$httpUtils.instance;
      const url = `/billings/${this.userID}`;
      HTTP.delete(url, this.userID)
        .then(res => {
          this.showSuccessMsg({ message: "Device Deleted!" });
          this.init();
          this.hide();
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    },
    validateInput() {
      this.deleteReason = document.forms["myForm"]["fname"].value;
      if (this.deleteReason == "") {
        alert("Name must be filled out");
        return false;
      }
      return true;
    },
    deletionDetails(callback) {
      if (!this.validateInput()) return;

      const httpUtils = this.$httpUtils;

      // what to delete
      // return
      let userIds = this.userID;

      const HTTP = this.$httpUtils.instance;
      HTTP.post("/CustomerDeletedBillings", {
        billingId: this.userID,
        deleteReason: this.deleteReason
      })
        .then(res => {
          callback;
          console.log("customer deleted");
        })
        .catch(error => {
          this.showErrorMsg({
            message: error.response.data.error.message.message
          });
          this.showErrorMsg({ message: showInfoMsg });
        });
    },

    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    toggleEditCanvas(data) {
      this.regParams = data;
      this.editOffCanvas = !this.editOffCanvas;
    },
    formatDate(date) {
      return moment(date).format("DD MMMM, YYYY");
    },
    async init() {
      const httpUtils = this.$httpUtils.FINANCE_HTTP;
      // let url = `/billings/getAllUserSchedules`;
      let url = `billings/`;

      httpUtils
        .get(url)
        .then(response => {
          this.getUsers = response.data.data || [];
        })
        .catch(error => {
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    }
  },
  async mounted() {
    await this.init();
  }
};
</script>

<style scoped>
.ellipsis_style {
  font-size: 30px;
  color: #1388bd;
}
.pagin_style {
  color: #85878d;
}
.action_delete {
  color: red;
}
.action_delete:hover {
  background-color: red;
  color: whitesmoke;
}
.action_update {
  color: #1388bd;
}
.action_update:hover {
  background-color: #1388bd;
  color: whitesmoke;
}
.el-input__inner {
  border-radius: 10px;
  /* width: 360px; */
  background-color: #eff0f4;
  border-color: #eff0f4;
}
.triangle {
  /* background-color: red; */
  width: 40%;
  margin-left: auto;
  margin-right: auto;
}
.form {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

h4 {
  font-weight: 600;
  color: #6a707e;
  border: none;
  text-align: center;
}

.row {
  margin: 20px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.button-delete {
  padding: 5px;
  color: white;
  border-color: red;
  background: red;
  border-radius: 8px;
  width: 49%;
  margin-right: -7px;
}

.button-delete:hover {
  padding: 5px;
  color: white;
  border-color: rgb(146, 1, 1);
  background: rgb(146, 1, 1);
  border-radius: 8px;
  width: 49%;
  margin-right: -7px;
}

.red-border {
  border: 2px solid red;
  width: 30px;
}

.button-cancel {
  padding: 5px;
  color: grey;
  border: 1px solid grey;
  background: white;
  width: 49%;
  border-radius: 8px;
}

.button-cancel:hover {
  padding: 5px;
  color: white;
  border: 1px solid grey;
  background-color: #85878d;
  width: 49%;
  border-radius: 8px;
}

table th,
table th span {
  font-size: 0.7em;
}
.billing-table-height {
  height: calc(100vh - 250px);
}
.uk-offcanvas-bar {
  width: 90vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/adminBilling/BillingListing.vue